import React from "react";

const YouTubeVideo = ({ title = "YouTube Video" }) => {
  const containerStyle = {
    position: "relative",
    width: "100%",
    paddingBottom: "56.25%", // 16:9 aspect ratio
    height: 0,
    overflow: "hidden",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    margin: "20px 0",
  };

  const iframeStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "none",
  };

  return (
    <div style={containerStyle}>
      <iframe
        style={iframeStyle}
        src={`https://www.youtube.com/embed/kn2jw2ElHrg?si=PLqSCAG7ImEuQz6w`}
        title={title}
        frameBorder="0"
        allowFullScreen
      />
    </div>
  );
};

export default YouTubeVideo;
